import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const content = {
  privacy: {
    title: 'Política de Privacidad',
    body: <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-29">
        <p data-id="element-30">
          <strong className="text-white" data-id="element-31">Última actualización:</strong> Febrero
          2026
        </p>
        <p data-id="element-32">
          En Microvictorias, nos tomamos muy en serio la privacidad de nuestros
          usuarios. Esta política describe cómo recopilamos, usamos y protegemos
          tu información personal.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-33">
          1. Información que recopilamos
        </h3>
        <p data-id="element-34">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos datos de tarjetas de crédito directamente.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-35">
          2. Uso de la información
        </h3>
        <p data-id="element-36">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido, enviar confirmaciones de compra y brindarte soporte
          si lo necesitas.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-37">
          3. Protección de datos
        </h3>
        <p data-id="element-38">
          Utilizamos cifrado SSL y procesadores de pago seguros para proteger
          toda tu información personal y financiera.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-39">4. Terceros</h3>
        <p data-id="element-40">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto los necesarios para procesar tu compra.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-41">
          5. Tus derechos
        </h3>
        <p data-id="element-42">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. Responderemos a tu solicitud en un plazo máximo de 30 días.
        </p>
      </div>
  },
  terms: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-43">
        <p data-id="element-44">
          <strong className="text-white" data-id="element-45">Última actualización:</strong> Febrero
          2026
        </p>
        <p data-id="element-46">
          Al adquirir el ebook "Microvictorias", aceptas los siguientes términos
          y condiciones de uso.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-47">
          1. Producto digital
        </h3>
        <p data-id="element-48">
          Este es un producto digital descargable. Una vez completada la compra,
          recibirás acceso inmediato al ebook en formato PDF.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-49">
          2. Uso personal
        </h3>
        <p data-id="element-50">
          El ebook es para uso personal únicamente. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-51">
          3. Política de reembolso
        </h3>
        <p data-id="element-52">
          Ofrecemos una garantía de satisfacción. Si no estás conforme con el
          producto, puedes solicitar un reembolso dentro de los primeros 7 días
          posteriores a la compra.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-53">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-54">
          El contenido del ebook es informativo y educativo. No sustituye el
          consejo médico profesional. Consulta a un profesional de la salud
          antes de realizar cambios significativos en tu dieta o rutina de
          ejercicios.
        </p>

        <h3 className="text-white font-semibold text-base pt-2" data-id="element-55">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-56">
          Todo el contenido, diseño y marca de Microvictorias están protegidos
          por derechos de autor. Todos los derechos reservados.
        </p>
      </div>
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-[#050505] border-t border-gray-900" data-id="element-57">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-58">
          <p className="text-gray-600 text-sm" data-id="element-59">
            © {new Date().getFullYear()} Microvictorias. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-60">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#22C55E] text-sm transition-colors duration-200" data-id="element-61">
              Política de Privacidad
            </button>
            <span className="w-1 h-1 rounded-full bg-gray-700" data-id="element-62" />
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#22C55E] text-sm transition-colors duration-200" data-id="element-63">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-64">
        {activeModal && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={() => setActiveModal(null)} data-id="element-65" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-66">
              <div className="bg-[#111111] border border-gray-800 rounded-2xl w-full max-w-lg max-h-[80vh] overflow-hidden shadow-2xl pointer-events-auto" data-id="element-67">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-800" data-id="element-68">
                  <h3 className="text-xl font-bold text-white" data-id="element-69">
                    {content[activeModal].title}
                  </h3>
                  <button onClick={() => setActiveModal(null)} className="text-gray-500 hover:text-white transition-colors p-1 rounded-lg hover:bg-gray-800" data-id="element-70">
                    <X className="w-5 h-5" data-id="element-71" />
                  </button>
                </div>

                {/* Body */}
                <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-72">
                  {content[activeModal].body}
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}